import React from "react";
import PropTypes from "prop-types";
import {Line, HeaderContainer} from './section-header.styled';

/**
 * Reusable component for rendering a section header with flanking lines
 *
 * @param {string}          title - the title for the header
 * @param {string|object}   [className] - additional class(es) added to header element
 */
export const SectionHeader = ({ title, className = "" }) => {
    return (
        <HeaderContainer className={className} data-component="section-header">
            <Line />
            <span className="spark-text-16px-secondary">{title}</span>
            <Line />
        </HeaderContainer>
    );
};

SectionHeader.propTypes = {
    title: PropTypes.string.isRequired,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
